import { render, staticRenderFns } from "./uniapp.vue?vue&type=template&id=5670a3b3&scoped=true"
import script from "./uniapp.vue?vue&type=script&lang=js"
export * from "./uniapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5670a3b3",
  null
  
)

export default component.exports